var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-logo",class:{ 'is-mobile': _vm.mobile }},[_c('b-link',{attrs:{"href":_vm.route}},[_c('ImageVector',{attrs:{"filename":_vm.logo,"fallback":_vm.fallback,"alt":_vm.$t('admin.nav.Wunschgutschein')}})],1),(!_vm.mobile)?_c('LanguageSwitcher'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }